import { render } from "./Coregs.vue?vue&type=template&id=13dc3b00&scoped=true"
import script from "./Coregs.vue?vue&type=script&lang=js"
export * from "./Coregs.vue?vue&type=script&lang=js"

import "./Coregs.vue?vue&type=style&index=0&id=13dc3b00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13dc3b00"]])

export default __exports__